import toSorted from "array.prototype.tosorted";
if (!Array.prototype.toSorted) {
  toSorted.shim();
}

import { AppProps } from "next/app";
import { ApolloProvider } from "@apollo/client";
import { createApolloClient } from "@/repositories/client";
import AuthProvider from "@/contexts/AuthContext";
import { Global } from "@emotion/react";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { globalStyle } from "@/styles/globalStyle";
import {
  SnackBarContainer,
  SnackBarProvider,
} from "@moneyforward/mfx_biz_react_components";
import { useEffect, useState } from "react";
import { RecoilRoot } from "recoil";
import Rollbar from "rollbar";
import { SystemErrorPage } from "@/components/pages";
import rollbarConfig from "@/libs/rollbarConfig";

const rollbar = new Rollbar(rollbarConfig);

function App({ Component, pageProps }: AppProps) {
  const mockEnabled = process.env.NEXT_PUBLIC_API_MOCKING === "enabled";
  const [mockServerWorkerReady, setMockServerWorkerReady] = useState(
    !mockEnabled
  );

  useEffect(() => {
    if (mockEnabled) {
      require("@/repositories/mocks")
        .start()
        .then(() => {
          setMockServerWorkerReady(true);
        });
    }
  }, []);

  if (mockEnabled && !mockServerWorkerReady) {
    return <div>Starting mock server...</div>;
  }

  return (
    <Provider instance={rollbar} config={rollbarConfig}>
      <ErrorBoundary fallbackUI={SystemErrorPage}>
        <RecoilRoot>
          <ApolloProvider client={createApolloClient()}>
            <AuthProvider>
              <SnackBarProvider>
                <Global styles={globalStyle} />
                <Component {...pageProps} />
                <SnackBarContainer />
              </SnackBarProvider>
            </AuthProvider>
          </ApolloProvider>
        </RecoilRoot>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
